import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { c1, c16, offcanvasColors } from "src/app/core/services/constants";
import { IndexDBService } from "src/app/core/services/indexDB.service";
import { Background, MenuButton, Tab } from "src/app/core/services/interface";
import { MiddlwareService } from "src/app/core/services/middleware.service";
import { WebsocketService } from "src/app/core/services/websocket.service";
import { BuilderService } from "src/app/sharedservices/builder.service";

@Component({
  selector: "app-tab-bg-color-component",
  templateUrl: "./tab-bg-color-component.component.html",
  styleUrls: ["./tab-bg-color-component.component.scss"],
})
export class TabBgColorComponent implements OnInit, OnDestroy {
  constructor(
    private mdw: MiddlwareService,
    public indexDBService: IndexDBService
  ) {}

  @Input() tab_id: string;
  @Input() config: any;
  tab: Tab;
  mode: string;

  // default values
  imageLg: string;
  imageSm: string;
  image: string;
  icon: any;
  icon_ios: any;
  title: string;
  roundedBottom = true;
  offCanvasSubscription: any;
  currentTabSubscription: any;
  colorsComponentSubscription: any;

  enableStickyPost = false;
  textColor = "#ffffff";
  stickyBgColor = "#ff2121";
  offcanvasColors = offcanvasColors;

  off_canvas_key: string = "tab";
  newTab = false;
  videoUrl = "";
  videoDesc = "";
  bgColor = "";
  modalRef?: BsModalRef;
  isAndroid: boolean;
  data: any;
  tabList = {};
  sortedTabList = [];
  current_tab_id;
  component_id: string;
  field_id: string;
  enableCustomColor = false;
  enableCustomColorIOS = false;
  sync;
  labelColor;
  labelDarkColor;
  labelColorIOS;
  labelDarkColorIOS;
  light: boolean = true;
  colors: any = {};
  color_schema: any;
  color_schema_ios: any;
  imageConfig: any = {};
  imageDarkConfig: any = {};
  row_id: string;
  currentMenuSubscription: any;
  sortedButtonList: any[];
  buttonList: any;
  bgimage: string = null;
  toggleDarkImage = false;
  start_color: string;
  end_color: string;
  enableCustomGradientColor: boolean = false;
  startColor: string;
  startDarkColor: string;
  endColor: string;
  endDarkColor: string;

  ngOnInit() {
    this.field_id = "tab_BG_color";

    this.currentTabSubscription = this.mdw.currentTabContainer$.subscribe(
      (data) => {
        if (
          data &&
          (data["cat"] == "home" || data["cat"] == "side") &&
          data.target === "tabSetting" &&
          data.current_tab &&
          this.tab_id &&
          data.current_tab.id == this.tab_id &&
          data["component_id"] != this.component_id
        ) {
          this.data = data;
          this.sortedTabList = this.data["sortedTabList"];
          this.tabList = this.data["tabList"];
          this.tab = data["tabList"][this.tab_id];
          this.tabFunction();
        }
      }
    );

    this.offCanvasSubscription = this.mdw.offCanvasContainer$.subscribe(
      (data) => {
        if (
          data &&
          data.off_canvas_key &&
          data.off_canvas_key === "tab" &&
          data.tab &&
          data.tab.id &&
          data.tab.id == this.tab_id
        ) {
          this.TabIntialize(data);
          this.tabFunction();
        }
      }
    );
  }

  TabIntialize(data) {
    this.data = data.data;
    if (data.tab.id == this.tab_id) {
      this.tab = { ...data.tab };
      this.component_id = this.tab.id + this.field_id;
    }
    this.sortedTabList = this.data["sortedTabList"];
    this.tabList = this.data["tabList"];
    this.mode = localStorage.getItem("mode");
  }

  tabFunction() {
    if (this.tab) {
      this.isAndroid = localStorage.getItem("mode")[0] === c1.ANDROID ? true : false;
      this.colors = this.isAndroid ? this.config.colors.color_schema : this.config.colors.color_schema_ios;

      if (this.isAndroid) {
        if(this.tab.tab_bg && this.tab.tab_bg.start && this.tab.tab_bg.end && this.tab.tab_bg.start_dark && this.tab.tab_bg.end_dark){
          this.startColor = this.tab.tab_bg.start;
          this.startDarkColor = this.tab.tab_bg.start_dark;
          this.endColor = this.tab.tab_bg.end;
          this.endDarkColor = this.tab.tab_bg.end_dark;
          this.enableCustomGradientColor = true;
        }else{
          this.enableCustomGradientColor = false;
        }
      } else {
        if(this.tab.tab_bg_ios && this.tab.tab_bg_ios.start && this.tab.tab_bg_ios.end && this.tab.tab_bg_ios.start_dark && this.tab.tab_bg_ios.end_dark){
          this.startColor = this.tab.tab_bg_ios.start;
          this.startDarkColor = this.tab.tab_bg_ios.start_dark;
          this.endColor = this.tab.tab_bg_ios.end;
          this.endDarkColor = this.tab.tab_bg_ios.end_dark;
          this.enableCustomGradientColor = true;
        }else{
          this.enableCustomGradientColor = false;
        }
      }
    }
  }

  toggleGradientColor(event) {
    this.enableCustomGradientColor = event;

    if (this.isAndroid || this.sync) {
      if (this.enableCustomGradientColor) {
        this.startColor = this.colors.schemes.light[this.config.init_start];
        this.startDarkColor = this.colors.schemes.dark[this.config.init_start];
        this.endColor = this.colors.schemes.light[this.config.init_end];
        this.endDarkColor = this.colors.schemes.dark[this.config.init_end];
        this.tab = {
          ...this.tab,
          tab_bg: {
            ...this.tab.tab_bg,
            start: this.startColor,
            end: this.endColor,
            start_dark: this.startDarkColor,
            end_dark: this.endDarkColor,
          },
        };
      } else {
        this.startColor = null;
        this.labelDarkColor = null;
        this.endColor = null;
        this.endDarkColor = null;
        delete this.tab.tab_bg.start;
        delete this.tab.tab_bg.end;
        delete this.tab.tab_bg.start_dark;
        delete this.tab.tab_bg.end_dark;
      }
    }

    if (!this.isAndroid || this.sync) {
      if (this.enableCustomGradientColor) {
        this.startColor = this.colors.schemes.light[this.config.init_start_ios];
        this.startDarkColor =
          this.colors.schemes.dark[this.config.init_start_ios];
        this.endColor = this.colors.schemes.light[this.config.init_end_ios];
        this.endDarkColor = this.colors.schemes.dark[this.config.init_end_ios];
        this.tab = {
          ...this.tab,
          tab_bg_ios: {
            ...this.tab.tab_bg_ios,
            start: this.startColor,
            end: this.endColor,
            start_dark: this.startDarkColor,
            end_dark: this.endDarkColor,
          },
        };
      } else {
        this.startColor = null;
        this.labelDarkColor = null;
        this.endColor = null;
        this.endDarkColor = null;
        delete this.tab.tab_bg_ios.start;
        delete this.tab.tab_bg_ios.end;
        delete this.tab.tab_bg_ios.start_dark;
        delete this.tab.tab_bg_ios.end_dark;
      }
    }
    this.updateTabData();
  }

  startColorChange(value, manual, mode = "color") {
    let color = null;
    let onMode: string;
    if (mode == "color") {
      onMode = "colorContainer";
    } else {
      onMode = "color";
    }
    color =
      manual == true
        ? this.mdw.isValidHexaCode(value.target.value)
          ? value.target.value
          : null
        : value;
    if (color) {
      this.isAndroid = localStorage.getItem("mode")[0] === c1.ANDROID ? true : false;
      this.colors = this.isAndroid ? this.config.colors.color_schema : this.config.colors.color_schema_ios;
      let customColor = this.mdw.customColor(color, this.colors.source);
      let onCustomColor = this.mdw.customColor(
        color,
        this.colors.source,
        onMode
      );
      this.startColor = customColor.light;
      this.startDarkColor = customColor.dark;
      this.endColor = onCustomColor.light;
      this.endDarkColor = onCustomColor.dark;

      if (this.isAndroid || this.sync) {
        this.tab.tab_bg.start = this.startColor;
        this.tab.tab_bg.start_dark = this.startDarkColor;
      }
      if (!this.isAndroid || this.sync) {
        this.tab.tab_bg_ios.start = this.startColor;
        this.tab.tab_bg_ios.start_dark = this.startDarkColor;
      }
      if (this.isAndroid || this.sync) {
        this.tab.tab_bg.end = this.endColor;
        this.tab.tab_bg.end_dark = this.endDarkColor;
      }
      if (!this.isAndroid || this.sync) {
        this.tab.tab_bg_ios.end = this.endColor;
        this.tab.tab_bg_ios.end_dark = this.endDarkColor;
      }
      this.updateTabData();
    }
  }

  endColorChange(value, manual, mode = "color") {
    let color = null;
    let onMode: string;
    if (mode == "color") {
      onMode = "colorContainer";
    } else {
      onMode = "color";
    }
    color =
      manual == true
        ? this.mdw.isValidHexaCode(value.target.value)
          ? value.target.value
          : null
        : value;
    if (color) {
      this.isAndroid = localStorage.getItem("mode")[0] === c1.ANDROID ? true : false;
      this.colors = this.isAndroid ? this.config.colors.color_schema : this.config.colors.color_schema_ios;
      let customColor = this.mdw.customColor(color, this.colors.source);
      let onCustomColor = this.mdw.customColor(
        color,
        this.colors.source,
        onMode
      );
      this.endColor = customColor.light;
      this.endDarkColor = customColor.dark;
      this.startColor = onCustomColor.light;
      this.startDarkColor = onCustomColor.dark;

      if (this.isAndroid || this.sync) {
        this.tab.tab_bg.end = this.endColor;
        this.tab.tab_bg.end_dark = this.endDarkColor;
      }
      if (!this.isAndroid || this.sync) {
        this.tab.tab_bg_ios.end = this.endColor;
        this.tab.tab_bg_ios.end_dark = this.endDarkColor;
      }
      if (this.isAndroid || this.sync) {
        this.tab.tab_bg.start = this.startColor;
        this.tab.tab_bg.start_dark = this.startDarkColor;
      }
      if (!this.isAndroid || this.sync) {
        this.tab.tab_bg_ios.start = this.startColor;
        this.tab.tab_bg_ios.start_dark = this.startDarkColor;
      }
      this.updateTabData();
    }
  }

  updateTabData() {
    //*must be there in all Tabs
    this.tabList[this.tab_id] = this.tab;

    let index = this.sortedTabList.findIndex((e) => e.id == this.tab_id);
    this.sortedTabList[index] = { ...this.tab };
    this.data["sortedTabList"] = this.sortedTabList;
    this.data["TabList"] = this.tabList;
    this.data["off_canvas_key"] = this.off_canvas_key;
    this.data["current_tab"] = this.tab;
    this.data["target"] = "tabSetting";
    this.data["component_id"] = this.component_id;

    this.mdw._currentTabContainer.next(this.data);
    this.mdw.changeTab({ tab: this.tab }, this.mode, false);
  }

  ngOnDestroy(): void {
    if (this.offCanvasSubscription) {
      this.offCanvasSubscription.unsubscribe();
    }

    if (this.currentTabSubscription) {
      this.currentTabSubscription.unsubscribe();
    }
  }
}
